import type {BaseControlledListItem} from '@Components/controlled-list/controlled-list.types';

export interface ControlledListSeasonalItemProps extends BaseControlledListItem {
  seasonType: ControlledListSeasonalItemType;
  showSelectionCheckmark?: boolean;
  isDisabled?: boolean;
  textClassName?: string;
  iconPlacement?: IconPlacement;
}

export enum ControlledListSeasonalItemType {
  HALLOWEEN = 'halloween',
  CHRISTMAS = 'christmas',
}

export enum IconPlacement {
  Left = 'left',
  Right = 'right'
}